var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChatConversaMensagem.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1a347bdf\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChatConversaMensagem.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/chat/components/ChatConversaMensagem.vue
// module id = 1099
// module chunks = 17